/**
 * LCID (Locale ID) constants for internationalization
 * These numeric identifiers correspond to Windows LCID values
 */
(function() {
  'use strict';

  angular.module('core').constant('lcidConstants', {
    ENGLISH_US: 1033,
    ENGLISH_GB: 2057,
    SPANISH_US: 21514
  });
})();
